import type { CreateOrganizationUserInvitationPayload } from "@/schema/organization-invitation"

import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export function organizationFetch<T>(
  context: ApiContext,
  organizationId: string,
  route: string,
  options?: RequestInit
) {
  return apiContextFetch<T>(
    context,
    organizationId ? `organizations/${organizationId}/${route}` : `company/${route}`,
    options
  )
}

export function createOrganizationUserInvitation(
  context: ApiContext,
  organizationId: string,
  payload: CreateOrganizationUserInvitationPayload
) {
  return organizationFetch<void>(context, organizationId, "user_invitations", {
    method: "POST",
    body: JSON.stringify({ organization_user_invitation: payload }),
  })
}

export function updateOrganizationUserPreference(
  context: ApiContext,
  organizationId: string,
  userId: string,
  defaultCompanyId: string | null
) {
  return organizationFetch<void>(context, organizationId, `user_preferences/${userId}`, {
    method: "PUT",
    body: JSON.stringify({ user_preference: { default_company_id: defaultCompanyId } }),
  })
}
